/**
 * Start Galaxy Personalization
 * (popup showing under some conditions)
 */
const initPersonalization = function () {
	if (!window.GalaxyHelpers) return;

	window.GalaxyHelpers.personalization({
		callback: function (campaign) {
			const $el = $(campaign.html);

			$('body').append($el);

			const $modal = $el.find('.js-modal-personalization');
			$el.find('.js-p-remove-if-empty').each(function () {
				if ($(this).text().trim() == '') $(this).hide();
			});

			$modal.modal('show');

			initLoopTrap($modal);

			$modal.find('.js-modal-fullsize-image').each(function () {
				const $holder = $(this);
				const $img = $holder.find('img');
				const img = $img[0];
				let imgSrc = img.currentSrc;

				function checkImage() {
					imgSrc = img.currentSrc || img.src;

					$holder.css({ backgroundImage: `url(${imgSrc})` });
				}

				if (imgSrc) {
					$holder.css({ backgroundImage: `url(${imgSrc})` });
				} else {
					$img.on('load', function () {
						checkImage(img)
					});

					// Fix for IE if image is cached
					if (img.complete) checkImage(img);
				}
			});

			campaign.callbackDisplay(); /* callback to notifiy Galaxy that the popup has been seen */
		}
	});
};

function initLoopTrap($elements) {
	$elements.each(function () {
		const $container = $(this);
		const $firstEl = $container.find('a:visible:not([tabindex="-1"]),button:visible:not([tabindex="-1"]),input:visible:not([tabindex="-1"])').first();
		const $lastEl = $container.find('a:visible:not([tabindex="-1"]),button:visible:not([tabindex="-1"]),input:visible:not([tabindex="-1"])').last();

		$lastEl.on('keydown', function (e) {
			if (e.keyCode == 9 && !e.shiftKey) {
				e.preventDefault();
				$firstEl.focus();
			}
		});

		$firstEl.on('keydown', function (e) {
			if (e.keyCode == 9 && e.shiftKey) {
				e.preventDefault();
				$lastEl.focus();
			}
		});
	});
}

export default initPersonalization;
